import React from 'react';
import CarModels from '../../containers/CarModels/CarModels';

const CarModelsPage = () => {
  return <CarModels />;
};

export default CarModelsPage;
